export class ValueDependencyBehaviour {
  constructor(config, dependency) {
    this.type = 'value'
    this.dependency = dependency
    this.config = config
  }

  getValue() {
    return this.config.from[this._valueFromTrackingField()]
  }

  _valueFromTrackingField() {
    const input = this.dependency.trackingFieldInput

    return input ? input.value : null
  }
}
